export const storeFavoriteMarkerSvg = `
<svg width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g filter="url(#filter0_d_5163_19320)">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M14 24.2737C19.5228 24.2737 24 19.7965 24 14.2737C24 8.75083 19.5228 4.27368 14 4.27368C8.47715 4.27368 4 8.75083 4 14.2737C4 19.7965 8.47715 24.2737 14 24.2737Z" fill="#F5EBDC"/>
  </g>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8694 21.4987L8.03192 15.4862C6.95928 14.3576 6.69561 12.6836 7.36942 11.2799C7.94174 10.06 9.16566 9.27892 10.5132 9.27368C11.2454 9.27323 11.9581 9.51006 12.5444 9.94868L13.5007 10.6487L13.8694 10.9237L14.2382 10.6487L15.2007 9.94868C15.7851 9.51094 16.4955 9.27413 17.2257 9.27368C18.5668 9.28462 19.7824 10.065 20.3507 11.2799C21.0343 12.676 20.7857 14.3492 19.7257 15.4862L13.8694 21.4987Z" fill="#FF8732"/>
  <defs>
    <filter id="filter0_d_5163_19320" x="0" y="0.273682" width="28" height="28" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset/>
      <feGaussianBlur stdDeviation="2"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5163_19320"/>
      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5163_19320" result="shape"/>
    </filter>
  </defs>
</svg>
`;
